// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.questions{
	text-align: center;
	padding: 1.7em 0 1.2em;
}
.questions__numbers{
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: 0.6em;
}
.questions__number{
	background: #161616;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 0.9375em;
	border-radius: 100%;
	width: 2.5rem;
	height: 2.5rem;
	margin: 0 0.125rem;
	padding-top: 0.2rem;
	position: relative;
}
.questions__number.correct{
	background: #009465;
}
.questions__ico{
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	opacity: 0.3; 
}
.questions__number.correct .questions__ico{
	opacity: 1;
}
.questions__title{
	font-size: 0.9375em;
	line-height: 1.3333;
}
@media(min-width: 100vh){
	.questions{ 
	    padding: 2.4em 0 1.9em;
	}
	.questions__number{
		font-size: 0.961em;
		padding-top: 0.1rem;
		width: 2.5625rem;
		height: 2.5625rem;
	}
	.questions__title{
		font-size: 0.75em;
	}
}`, "",{"version":3,"sources":["webpack://./src/include/Questions/questions.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,sBAAsB;AACvB;AACA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,oBAAoB;AACrB;AACA;CACC,mBAAmB;CACnB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,mBAAmB;CACnB,mBAAmB;CACnB,aAAa;CACb,cAAc;CACd,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;AACnB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,WAAW;CACX,YAAY;CACZ,YAAY;AACb;AACA;CACC,UAAU;AACX;AACA;CACC,mBAAmB;CACnB,mBAAmB;AACpB;AACA;CACC;KACI,sBAAsB;CAC1B;CACA;EACC,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;CAClB;CACA;EACC,iBAAiB;CAClB;AACD","sourcesContent":[".questions{\n\ttext-align: center;\n\tpadding: 1.7em 0 1.2em;\n}\n.questions__numbers{\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin-bottom: 0.6em;\n}\n.questions__number{\n\tbackground: #161616;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tfont-size: 0.9375em;\n\tborder-radius: 100%;\n\twidth: 2.5rem;\n\theight: 2.5rem;\n\tmargin: 0 0.125rem;\n\tpadding-top: 0.2rem;\n\tposition: relative;\n}\n.questions__number.correct{\n\tbackground: #009465;\n}\n.questions__ico{\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\twidth: 100%;\n\theight: 100%;\n\topacity: 0.3; \n}\n.questions__number.correct .questions__ico{\n\topacity: 1;\n}\n.questions__title{\n\tfont-size: 0.9375em;\n\tline-height: 1.3333;\n}\n@media(min-width: 100vh){\n\t.questions{ \n\t    padding: 2.4em 0 1.9em;\n\t}\n\t.questions__number{\n\t\tfont-size: 0.961em;\n\t\tpadding-top: 0.1rem;\n\t\twidth: 2.5625rem;\n\t\theight: 2.5625rem;\n\t}\n\t.questions__title{\n\t\tfont-size: 0.75em;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
